//
// Handling der Progressbar in Artikel Detail ansicht, check ob hidden, update scroll tiefe
//

import contentTracker from "./InhaltGelesen";

document.addEventListener('DOMContentLoaded', progressBar);

function progressBar() {

    const progressBarArtikel = document.getElementById('iww-readerbar');
    const progressBarNewsletter = document.getElementById('iww-readerbar-newsletter');
    const artikeldetail = document.querySelector(`[id^="artikel_detail_"]`);

    const urlParams = new URLSearchParams(window.location.search);
    const fromParam = urlParams.get('from');

    let progressBar = null;

    if (artikeldetail) {
        let button_back = null;
        let button_back_blocked = null;

        let button_forward = null;
        let button_forward_blocked = null;


        // Wir befinden uns in Artikeldetail der Fortschrittsbalken ist sichtbar
        // sonst return
        if (!(artikeldetail && fromParam)) {
            return;
        }

        if (progressBarArtikel && !fromParam.includes("nl_")) {
            button_back = document.getElementById("button_back");
            button_back_blocked = document.getElementById("button_back_blocked");

            button_forward = document.getElementById("button_forward");
            button_forward_blocked = document.getElementById("button_forward_blocked");

            let heftId = artikeldetail.getAttribute("data-heft-issue");

            if (fromParam !== null && (fromParam !== heftId)) {
                return;
            }

            progressBar = progressBarArtikel.querySelector('#progress_bar');
        } else if (progressBarNewsletter && fromParam.includes("nl_")) {
            button_back = document.getElementById("button_back_newsletter_" + fromParam.replace("nl_", ""));
            button_back_blocked = document.getElementById("button_back_blocked_newsletter_" + fromParam.replace("nl_", ""));

            button_forward = document.getElementById("button_forward_newsletter_" + fromParam.replace("nl_", ""));
            button_forward_blocked = document.getElementById("button_forward_blocked_newsletter_" + fromParam.replace("nl_", ""));

            progressBar = progressBarNewsletter.querySelector('#progress_bar');
        }

        // Verfügbare Knöpfe anzeigen
        if (button_back !== null) {
            button_back.classList.add("xlg:block");
        } else if (button_back_blocked !== null) {
            button_back_blocked.classList.add("xlg:block");
        }

        if (button_forward !== null) {
            button_forward.classList.add("xlg:block");
        } else if (button_forward_blocked !== null) {
            button_forward_blocked.classList.add("xlg:block");
        }

        // Exit hier wenn keine Progressbar vorhanden
        if (progressBar == null || document.getElementById("paywall_login") !== null) {
            return;
        }

        const newsliste = document.getElementById("newsliste");
        const newslisteTop = newsliste.getBoundingClientRect().top + window.scrollY;
        // Mal 0.9 um Artikel bei 100% gelesen Artikelende in unterem drittel des bildschirms
        const windowHeight = window.innerHeight * 0.9;

        // Einmal onload ausführen um progress auch schon vor dem ersten scrollen zu haben
        let scrollPosition = window.scrollY;
        let progress = (scrollPosition / (newslisteTop - windowHeight)) * 100;

        // progress is capped at 100% even if user scrolls down further
        if (progress > 100) {
            progress = 100;
        }

        progressBar.style.width = progress + '%';

        let ausgabeAbgeschlossenPopup;
        let aktuelleProgressbar;
        let ausgabeSuccess;
        if (fromParam.includes("nl_")) {
            ausgabeAbgeschlossenPopup = document.getElementById("iww-readerbar-newsletter").querySelector("[id='ausgabe_abgeschlossen']");
            aktuelleProgressbar = document.getElementById("iww-readerbar-newsletter");
            ausgabeSuccess = document.getElementById("iww-readerbar-newsletter").querySelector('[id="ausgabe_abgeschlossen_success"]');

        } else {
            ausgabeAbgeschlossenPopup = document.getElementById("iww-readerbar").querySelector("[id='ausgabe_abgeschlossen']");
            aktuelleProgressbar = document.getElementById("iww-readerbar");
            ausgabeSuccess = document.getElementById("iww-readerbar").querySelector('[id="ausgabe_abgeschlossen_success"]');
        }

        let alleGelesen;
        let gelesenCount = 0;
        let alleArtikelCount = 0;

        contentTracker.getContentIDsReadByType("artikel").then(articles_read => {
            aktuelleProgressbar.childNodes[1].lastChild.firstChild.childNodes.forEach(element => {
                if (element.id.startsWith("start_marker_")) {
                    alleArtikelCount = alleArtikelCount + 1;
                    let artikelID = element.id.replace("start_marker_", "");

                    if (articles_read !== null && articles_read.includes(artikelID)) {
                        gelesenCount = gelesenCount + 1;
                    }
                }
            });

            if (gelesenCount == alleArtikelCount && alleArtikelCount !== 0) {
                alleGelesen = true;
            } else {
                alleGelesen = false;
            }



            let aktuellerGelesen = null;

            let artikel = document.querySelector("[id^='artikel_detail']");
            if (artikel !== null) {
                let artikelID = artikel.id.replace("artikel_detail_", "");
                if (articles_read !== null && articles_read.includes(artikelID)) {
                    contentTracker.getContent(artikelID).then(artikelStatusInfo => {
                        if (artikelStatusInfo) {
                            if (parseInt(Math.floor(Date.now() / 1000)) - parseInt(artikelStatusInfo.updateDate) < 20) {
                                aktuellerGelesen = false;
                            } else {
                                aktuellerGelesen = true;
                            }
                        } else {
                            aktuellerGelesen = false;
                        }
                    });
                } else if (articles_read !== null) {
                    aktuellerGelesen = false;
                }
            }

            if (alleGelesen == false || !(aktuellerGelesen)) {
                ausgabeSuccess.parentElement.classList.remove("group/tooltip");
            } else {
                if (!ausgabeSuccess.parentElement.classList.contains("group/tooltip")) {
                    ausgabeSuccess.parentElement.classList.add("group/tooltip");
                }
            }

            let finished = false;
            let timeout;
            window.addEventListener('scroll', () => {

                let scrollPosition = window.scrollY;

                let progress = (scrollPosition / (newslisteTop - windowHeight)) * 100;
                let scrollDepth = (scrollPosition / (newslisteTop - windowHeight)) * 100;

                // progress is capped at 100% even if user scrolls down further
                if (progress > 100) {
                    progress = 100;
                }

                if (!aktuellerGelesen && alleGelesen && (scrollDepth > 90) && ausgabeSuccess !== null && !finished) {
                    finished = true;
                    if (ausgabeSuccess.classList.contains("invisible")) {
                        if (!timeout) {
                            ausgabeSuccess.classList.remove("invisible");
                            timeout = setTimeout(() => {
                                ausgabeSuccess.classList.add("invisible");
                                timeout = null;
                            }, 3000);
                        }
                    }
                } else if (!aktuellerGelesen && alleGelesen && (scrollDepth < 90) && ausgabeSuccess !== null) {
                    if (!ausgabeSuccess.classList.contains("invisible")) {
                        if (timeout) {
                            clearTimeout(timeout);
                            ausgabeSuccess.classList.add("invisible");
                        }
                    }
                }

                if (alleGelesen == false || !(finished || aktuellerGelesen)) {
                    ausgabeSuccess.parentElement.classList.remove("group/tooltip");
                } else {
                    if (!ausgabeSuccess.parentElement.classList.contains("group/tooltip")) {
                        ausgabeSuccess.parentElement.classList.add("group/tooltip");
                    }
                }

                progressBar.style.width = progress + '%';
            });

        });
    }
}
